exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".way[data-v-45bc7c2e]{height:40px;border-radius:10px 10px 0 0}.way>div[data-v-45bc7c2e]{width:calc(100%/3)}.way .select_style[data-v-45bc7c2e]{border-radius:10px 10px 0 0;background:#fff}.way1[data-v-45bc7c2e]{height:40px;border-radius:10px 10px 0 0}.way1>div[data-v-45bc7c2e]{width:calc(100%/2)}.way1 .select_style[data-v-45bc7c2e]{border-radius:10px 10px 0 0;background:#fff}.top-up>div[data-v-45bc7c2e]{width:calc(100%/3)}", ""]);

// exports
